// Komponenten <eui-dialog>:

import Vue from 'vue';

import { euiLifecycleStatusesMixin } from 'v-mixins/euiLifecycleStatusesMixin';
import euiDragAndDropEvents from 'v-directives/euiDragAndDropEvents';

// https://linusborg.github.io/portal-vue/#/guide
//import PortalVue from 'portal-vue';
import { Portal, PortalTarget } from 'portal-vue';

import euiMaintainDisabled from 'v-directives/euiMaintainDisabled';
import euiMaintainTabFocus from 'v-directives/euiMaintainTabFocus';

import euiDialogClasses from 'v-components/classes/euiDialogClasses';
import euiPopUpMenyClasses from 'v-components/classes/euiPopUpMenyClasses';
import euiModifieradSvg from 'v-components/euiModifieradSvg';
import euiMermeny from 'v-components/euiMermeny';
import euiKnapp from 'v-components/euiKnapp';

import { ssoTooltips } from 'ssoTooltips';

import { ValidationObserver } from 'vee-validate';

import VeeValidateInstanceMedRattOptions from 'VeeValidateInstanceMedRattOptions';
VeeValidateInstanceMedRattOptions.runOnce();		// Kör funktionen om den inte redan körts!

//// Obs! Det verkar som om use() nedan måste till för att rätt initiering ska göras för att man sen ska kunna använda ValidationProvider:
////import {
//////	ValidationObserver,
////	ValidationProvider,
//////	//withValidation
////} from 'vee-validate';
////
//// inject:false är för att den inte ska injecta en massa errors-objekt på alla/omnotiverade komponenter. Behövs inte då komponenterna ValidationObserver/ValidationProvider används:
//Vue.use(VeeValidate, { inject: false });

// Gemensam för alla sådana här komponenter på en sida, vilket är precis det vi vill:
let uniktIdCounter = 0;


//###################################################################################################

export default {

	name: 'eui-dialog',

	template: `
		<portal :name="portalName" :target-el="'#' + this.portalTargetName"
		>
			<!-- Måste vara ett "*single* root element"!
			NJET, inte när denna *inte* är "slim" längre, väl? -->


			<!--	Funkar inte, inte så här i alla fall. Hanteras ist m egen event-hanterare: @keyup.esc.stop.prevent="onKnappTryckt('avbryt')"-->
			<!-- Wrappad med en ValidationObserver (https://baianat.github.io/vee-validate/guide/components/validation-observer.html) för den eventualitet att dialogen innehåller någon/några ValidationProvider: -->
			<!-- '#default' nedan = 'v-slot:default' = nya sättet att sätta 'slot-scope' och kallas 'slot props' (slotProps): -->
			<!-- Slot props (https://baianat.github.io/vee-validate/guide/components/validation-observer.html#scoped-slot-data) satt även här (förutom i "anropande" <eui-dialog ...>), för den eventualitet att man vill komma åt observers från slot-innehållet: -->
			<validation-observer
				tag="div"
				#default="{
					dirty,
					pristine,
					validated,
					valid,
					invalid,
					pending,
					touched,
					untouched,
					errors,
					validate,
					reset
				}"

				v-if="visaDialogen"
				ref="panelen"
				:id="uniktId"
				class="_eui-dialogpanel"
				:class="{
					'-visas':visaDialogen && arSlutpositionerad,
					'-skuggad':vpMedSkuggadBakgrund && arOverstaDialogen,
					'-inaktiverad':skaVaraInaktiverad,
					'-osynlig':skaVaraOsynlig,
				}"
				:disabled="skaVaraInaktiverad"
			>


				<!-- Borttaget från nedan: Behövs inte och ställer bara till det vid stackning! Återinförd på prov:
					v-eui-maintain-disabled="{ disabled: visaDialogen, wholeDocumentExceptThisElement: true }"-->
				<!-- Och så, åter borttagen, på prov. Minns inte varför jag återinförde den. Anledning nu: Att en massa tabbara element på grundsidan blir disableade innebär också att de får viss transparens = fult!
					v-eui-maintain-disabled="{ disabled: visaDialogen && arAktiverad, wholeDocumentExceptThisElement: true }" -->
				<div
					ref="rutan"
					class="_eui-dialogruta -ram"
					:class="{
						'-med-fot':vpVisaFoten,
						'-is-beeing-moved':isBeeingMoved,
					}"
					:style="{
						'width':vpBreddMedEnhet,
						'display': draggedToElementPosition.x && 'block',
						'position': draggedToElementPosition.x && 'absolute',
						'left': draggedToElementPosition.x + 'px',
						'top': draggedToElementPosition.y + 'px',
					}"

					v-eui-maintain-tab-focus="visaDialogen && arAktiverad"
				>

					<!-- ####### Huvudet: -->

					<div v-if="vpVisaHuvudet"
						class="_eui-dialogruta_huvud -vit-bg"
					>

						<!-- ####### Verktygsfält (ist f huvudtext): -->

						<span v-if="vpVisaVerktygsfaltIstalletForHuvudText"
							class="_eui-dialogruta_verktygsfalt"
						>
							<slot name="verktygsfalt">
								<span>Ingen slot för verktygsfältet finns!</span>
							</slot>
						</span>

						<!-- ####### Huvudtext: -->

						<span
							class="_eui-dialogruta_huvudtext ellipsis"
							v-drag-and-drop-events="{ listening: arAktiverad, eventHandler: (e) => onDragAndDrop(e) }"
						>
							<slot name="huvudtext">
								<span v-html="huvudText"></span>
							</slot>
						</span>



						<!-- ####### Menyfältet: -->

						<span v-if="vpVisaMenyfaltet"
							class="_eui-dialogruta_menyfalt"
						>
							<!-- ####### Mermenyn: -->

							<eui-mermeny v-if="vpMenyConfig"
								:vp-meny-config.sync="vpMenyConfig"
								vp-burgare-ikon-av-storlek="1.7rem"
								@menyalternativ-valt-i-mermeny="onMenyalternativValt"
								style="width:40px; height:100%; display:inline-flex;"
							></eui-mermeny>

							<!-- ####### Stäng-knapp (x): -->

							<eui-knapp
								vp-css-modifier-class="-transparent"
								@tryckt="inaktiveraOchStangDenOppnadeDialogen()"
								style="
									width: 40px;
									height: 40px;
									padding: 10%;
									flex: none;
									border: .4em solid white;
									border-radius: 100%;
								"
							>

								<!--	:vp-svg-markup="svgikonStang"-->
								<eui-modifierad-svg
									vp-ikon="stang"
								></eui-modifierad-svg>

							</eui-knapp>

						</span>
					</div>

					<!-- ####### Kroppen: -->

					<div
						:class="{
							'-utan-padding':vpUtanPaddingPaKroppen,
							'-is-beeing-moved':isBeeingMoved,
						}"
						class="_eui-dialogruta_kropp -vit-bg"
					>

<!--<p class="-rod-text">valid: {{ valid }}
<br>pristine: {{ pristine }}</p>-->

						<div v-if="vpIkon"
							:class="vpIkonCssModifierClass"
							class="_eui-dialogruta_kropp-ikon"
						>
							<eui-modifierad-svg
								:vp-ikon="vpIkon"
								:style="!vpIkonCssModifierClass && { stroke: 'rgb(220, 218, 215)' }"
							></eui-modifierad-svg>
						</div>

						<div
							ref="kroppensInnehall"
							class="_eui-dialogruta_kropp-innehall"
						>

							<!-- Här skickas ValidationObserver-statusar (m.m.) med till sloten, som validationObserverMergedState: -->
							<!-- Funkade inte att gå via denna computed. Inte satt när den behövs: 	:validation-observer-merged-state="validationObserverMergedState" -->
							<slot
								:validation-observer-merged-state="{
									dirty,
									pristine,
									validated,
									valid,
									invalid,
									pending,
									touched,
									untouched,
									errors,
									validate,
									reset
								}"
							></slot>

						</div>
					</div>

					<!-- ####### Foten: -->

					<div v-if="vpVisaFoten"
						class="_eui-dialogruta_fot -vit-bg"
					>
						<span class="_eui-dialogruta_fottext ellipsis">
							<slot name="fottext">
								<span
									style="
										 display: block;
										 height: 100%;
									"
									v-html="vpFotText"
								></span>
							</slot>
						</span>

						<span v-if="vpVisaKnappfaltet && vpDialogConfig.knappar"
							class="_eui-dialogruta_knappfalt"
						>
							<!-- ####### Knapparna: -->

							<!-- Denna hantering av disabled standardknapp vid valideringsfel är bortplockad då den inte funkar så bra nu längre när valideringen endast sker vid change (och inte input):
								:vpInaktiverad="vpDialogConfig.standardknappIndex == knappIndex && invalid" -->

							<eui-knapp v-for="(knapp, knappIndex) in vpDialogConfig.knappar" :key="knappIndex"
								:knapp-index="knappIndex"
								:vp-css-modifier-class="knapp.cssModifierClass"
								v-html="knapp.text"
								@tryckt="onKnappTryckt(knappIndex)"
							></eui-knapp>

						</span>
					</div>

				</div>

			</validation-observer>
		</portal>
	`,

	components: {
		Portal,
		PortalTarget,
		euiModifieradSvg,
		euiKnapp,
		euiMermeny,
		'validation-observer': ValidationObserver,
	},

	mixins: [ euiLifecycleStatusesMixin ],

	directives: {
		euiMaintainDisabled,
		euiMaintainTabFocus,
		[euiDragAndDropEvents.name]: euiDragAndDropEvents,
	},

	props: {
		vpDialogId: {
			type: String,
			default: null,
		},

		vpDialogStack: {
			type: Array,
			required: true,
		},

		vpDialogConfig: {
			type: [euiDialogClasses.dialogConfig],
			required: true,
		},

		// Denna ska användas med .sync, dvs automagiskt lyssna på eventet 'update:vpVisaDialogen':
		vpVisaDialogen: {
			type: Boolean,
			default: false
		},

		vpElementMedDettaIdFlyttasVidVisningTillSistInomKroppensContainer: {
			type: String,
			default: null,
		},

		vpBreddMedEnhet: {
			type: String,
			default: '25rem'
		},

		vpUtanPaddingPaKroppen: {
			type: Boolean,
			default: false
		},

		vpMedSkuggadBakgrund: {		// Backdrop
			type: Boolean,
			default: true
		},

		vpVisaHuvudet: {
			type: Boolean,
			default: true
		},
		vpHuvudText: {
			type: String,		// Får innehålla viss inline html.
			default: '&nbsp;'
		},
		vpVisaVerktygsfaltIstalletForHuvudText: {
			type: Boolean,
			default: false
		},
		vpVisaMenyfaltet: {
			type: Boolean,
			default: true
		},
		vpMenyConfig: {	// null/undefined = saknas
			type: [euiPopUpMenyClasses.menyConfig, Object],
			default: null,
		},

		vpIkon: {	// null/undefined = saknas
			type: String,
			default: null,
		},
		vpIkonCssModifierClass: {
			type: String,
			default: null
		},

		vpVisaFoten: {
			type: Boolean,
			default: true
		},
		vpFotText: {
			type: String,		// Får innehålla viss inline html.
			default: '&nbsp;'
		},
		vpVisaKnappfaltet: {
			type: Boolean,
			default: true
		},
		vpInaktiverad: {
			type: Boolean,
			default: false
		},
		vpOsynlig: {
			type: Boolean,
			default: false
		},
	},

	data() {
		return {
			uniktIdNr: ++uniktIdCounter,
			uniktId: 'eui-dialog-unikt-' + uniktIdCounter,
			portalName: 'portal_eui-dialog-' + uniktIdCounter,
			portalTargetName: 'portal-target_eui-dialog-' + uniktIdCounter,

			//dialogensDimOchPos: { x: 0, y: 0, width: '', height: '' },

			// Obs! Endast för läsning, typ! Ändring sker alltid genom events till $root (där denna array finns):
			dialogStack: this.vpDialogStack,		// Arrays are reference types in JavaScript. *MEN* det funkar inte riktigt så i Vue!!

			huvudText: (this.vpVisaVerktygsfaltIstalletForHuvudText ? '&nbsp;' : this.vpHuvudText),

			visaDialogen: false,
			arAktiverad: false,		// Aktiverad för begränsad tab-sekvens, events etc. *Inte* === visas (men den kan bara vara aktiv om den visas)!
			arSlutpositionerad: false,

			standardknappIndex: this.vpDialogConfig.standardknappIndex,

			// Drag and drop:
			isBeeingMoved: false,
			draggingFromElementPosition: { x: 0, y: 0 },		// 'offset' = "outer".
			draggedToElementPosition: { x: undefined, y: undefined },		// 'offset' = "outer". undef => positionerad med flexbox.
		};
	},

	computed: {
		dialogId() {
			return this.vpDialogId || ('dialog-' + this.uniktIdNr);
		},

		antalDialogerPaStacken() {
			return this.dialogStack.length;
		},

		overstaDialogenIdNr() {
			return (this.antalDialogerPaStacken === 0 ? null : this.dialogStack[this.antalDialogerPaStacken - 1]);
		},

		arOverstaDialogen() {
			return this.uniktIdNr === this.overstaDialogenIdNr;
		},

		standardknapp() {
			return this.vpDialogConfig.knappar[this.standardknappIndex];
		},


		skaVaraOsynlig() {
			return (this.vpOsynlig || !this.lifecycleStatuses.mixinMountedAndNextTickHasOccured);	//AndSecondNextTickHasOccured);
		},

		skaVaraInaktiverad() {
			return (this.vpInaktiverad);				// || !this.lifecycleStatuses.mixinMountedAndSecondNextTickHasOccured);
		},
	},

	watch: {
		vpDialogStack(nyttVarde, tidigareVarde) {
			// Obs! Denna watch triggas *inte* vid initial rendering med värdet true!

			// Behövs inte (Arrays are reference types in JavaScript):
			// Jo, *behövs*!
			this.dialogStack = nyttVarde;

			// Aktivera/inaktivera *denna* dialog beroende på plats i stacken:
			if (this.arOverstaDialogen)
			{
				// Om den här dialogen *nu* är den översta:
				this.aktiveraDialogen();
			}
			else
			{
				// Annars: om den nu *inte* är den översta:
				this.inaktiveraDialogenOmDenArAktiverad();
			}
		},

		vpVisaDialogen(nyttVarde, tidigareVarde) {
			// Obs! Denna watch triggas *inte* vid initial rendering med värdet true!
			//console.log('watch:vpVisaDialogen', tidigareVarde + ' –> ' + nyttVarde, `[${this.uniktIdNr}]`, `${(this.visaDialogen ? 'visas' : '     ')} ${(this.arOverstaDialogen ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);
			this.visaDialogen = nyttVarde;
		},

		visaDialogen(nyttVarde, tidigareVarde) {
			// Obs! Denna watch triggas *inte* vid initial rendering med värdet true!
			//console.log('watch:visaDialogen', tidigareVarde + ' –> ' + nyttVarde, `[${this.uniktIdNr}]`, `${(this.visaDialogen ? 'visas' : '     ')} ${(this.arOverstaDialogen ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

			if (nyttVarde === true)
			{
				// NU ska den visas:

				this.$_undansparatActiveElement = document.activeElement;
				document.activeElement.blur();	// Inget (utanför den kommande dialogrutan) fokuserat.

				this.laggTillOverstPaDialogstacken();

				if (!this.arSlutpositionerad)
				{
					//this.sattDialogensDimOchPos();

					// För att elementet ska hinna visas:
					this.$nextTick(function () {
						//console.log('# aktiveraDialogen+NextTick', `[${this.uniktIdNr}]`, `${(this.visaDialogen ? 'visas' : '     ')} ${(this.arOverstaDialogen ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

						this.positioneraOmDialogenOmDenOverflowarBody();

						// 1. Invänta att den eventuella ompositioneringen ovan reaktivt slagit igenom i DOM (men innan webbläsaren renderat om skärmen):
						// DOM not updated yet
						//Vue.nextTick(function () {
						//		// DOM updated:
						//		// "nextTick allows you to do something after you have changed the data and VueJS has updated the DOM based on your data change, but before the browser has rendered those changed on the page":
						//	}
						//	, this	// Vue.nextTick 'this' context.
						//);
					});
				}
			}
			else
			{
				// NU ska den döljas:

				if (this.$_undansparatActiveElement)
					this.$_undansparatActiveElement.focus();

				// Skicka detta event *här*, för inte säkert att det kan skickas senare i reaktivitetssekvensen om hela komponenten hinner detroyas innan (hande nog också kunnat ligga i beforeDestroy()?):
				// Därför har också detta event namnet "..stangs" och inte "..stangd", men när det emittas så är det oåterkalleligt så att dialogen kommer att vara stängd inom båkdelar av en sekund:
				this.$emit('dialogen-stangs', this.dialogId);	// Egensatt Id (via prop) eller auto uppbyggt med uniktIdNr.

				this.taBortFranDialogstacken();
			}
		},
	},

	methods: {
		laggTillOverstPaDialogstacken() {
			//console.group('lagg-till-overst-pa-dialogstacken');
			//console.log('lagg-till-overst-pa-dialogstacken', `[${this.uniktIdNr}]`, `${(this.visaDialogen ? 'visas' : '     ')} ${(this.arOverstaDialogen ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

			// Sätt även rätt z-index på *portal-target*, så att den speglar dialogens (kommande) plats på stacken:
			// Sätts till > 1 för att hamna över eventuella injekterade saker i "parallella lager" (= "lagret under"), ex LastPass lösenordshanterare, index: 2:
			let el = document.getElementById(this.portalTargetName);
			el.style.zIndex = this.antalDialogerPaStacken + 101;		// 101-n

			// Själva ändringen av stacken måste ske på "rotnivån", för concurrency:
			this.$root.$emit('lagg-till-overst-pa-dialogstacken', this.uniktIdNr);

			//console.groupEnd('lagg-till-overst-pa-dialogstacken');
		},

		taBortFranDialogstacken() {
			//console.group('ta-bort-fran-dialogstacken');
			//console.log('ta-bort-fran-dialogstacken', `[${this.uniktIdNr}]`, `${(this.visaDialogen ? 'visas' : '     ')} ${(this.arOverstaDialogen ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

			// Själva ändringen av stacken måste ske på "rotnivån", för concurrency:
			this.$root.$emit('ta-bort-fran-dialogstacken', this.uniktIdNr);

			//console.groupEnd('ta-bort-fran-dialogstacken');
		},

		aktiveraDialogen() {
			//console.log('aktiveraDialogen', `[${this.uniktIdNr}]`, `${(this.visaDialogen ? 'visas' : '     ')} ${(this.arOverstaDialogen ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

			this.arAktiverad = true;

			// Flyttad: this.sattDialogensDimOchPos();

			// För att elementet ska hinna visas:
			this.$nextTick(function () {
				//console.log('# aktiveraDialogen+NextTick', `[${this.uniktIdNr}]`, `${(this.visaDialogen ? 'visas' : '     ')} ${(this.arOverstaDialogen ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

				// Flyttad: this.positioneraOmDialogenOmDenOverflowarBody();

				// 1. Invänta att den eventuella ompositioneringen ovan reaktivt slagit igenom i DOM (men innan webbläsaren renderat om skärmen):

				// DOM not updated yet
				Vue.nextTick(function () {
						// DOM updated:
						// "nextTick allows you to do something after you have changed the data and VueJS has updated the DOM based on your data change, but before the browser has rendered those changed on the page":

						// 2: Invänta att webbläsaren även uppdaterat skärmen:




						//! Flyttat till updated():
						//// Flytta in detta el från sist i body till dialogrutans kropp:
						//let target = document.getElementById('docTargetEl');
						//let elToMove = document.getElementById(this.vpElementMedDettaIdFlyttasVidVisningTillSistInomKroppensContainer);
						//target.appendChild(elToMove);
						//elToMove.style.display = 'flex';		// none => flex





						// Grrrr!!! Nedan funkade INTE med andra testade angreppssätt: Ersatt med RÅ och OTILLFÖRLITLIG och KORKAD timeout istället:

						// Todo: Ett ännu modernare sätt, som vi nog borde anv genomgående är anonymous function med () => {}, som vad jag förstår automagiskt får "rätt" this. Testar:
						// https://www.vinta.com.br/blog/2015/javascript-lambda-and-arrow-functions:
						// "One of the major advantages of arrow functions is that it does not have it's own this value. It's this is lexically bound to the enclosing scope."
						// "Because this is lexically bound you can't change it; call() and apply() will not be able to provide another value for this."
						// (Ännu fler sätt att lösa 'this' beskrivs på https://stackoverflow.com/a/8670894/593779.)
						setTimeout(() => {
								// 'this' = anroparens kontext.

								if (this.arAktiverad)
								{
									// Om dialogen *fortfarande* ska vara aktiv:

									// Njet, sätts tidigare, i laggTillOverstPaDialogstacken(), istället:
									//// Sortera alla dialoger (portal targets) i rätt stack-ordning:
									//let plats = 0;
									//for (const idNr of this.vpDialogStack)
									//{
									//	let panelEl = document.getElementById(this.uniktIdText(idNr));

									//	panelEl.parentElement	// = vue-portal-targeten.
									//		.style.zIndex = ++plats;
									//}

									this.startaEventLyssningForStangningAvDialogen();

									// Flyttat till de enskilda komponenterna för form fields:

									// Todo: Nackdel: Det blir svårt att sätta focus *igen* då dialogen varit inaktiverad och sedan aktiveras igen (ex efter en meddelande-dialog visats). Behöver kanske en omdesign!?

									//// Sätt autofocus om sådant attribut finns inom dialogen:
									//const afEl = this.$refs.rutan.querySelector('[autofocus]');
									//afEl && afEl.focus();
									////afEl && afEl.select();	// Även select. Eller?
								}
							}
							, 200	// ms
						);
					}
					, this	// Vue.nextTick 'this' context.
				);
			});
		},

		inaktiveraDialogenOmDenArAktiverad() {
			// Obs! Denna måste palla att anropas även om dialogen *inte* är aktiverad:
			//console.log('inaktiveraDialogenOmDenArAktiv', `[${this.uniktIdNr}]`, `${(this.visaDialogen ? 'visas' : '     ')} ${(this.arOverstaDialogen ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

			if (this.arAktiverad)
			{
				//console.log('inaktiveraDialogen (den är aktiv!)', `[${this.uniktIdNr}]`, `${(this.visaDialogen ? 'visas' : '     ')} ${(this.arOverstaDialogen ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

				this.stoppaEventLyssningForStangningAvDialogen();

				this.$emit('dialogen-inaktiverad');
			}

			this.arAktiverad = false;
		},

		//sattDialogensDimOchPos() {
		//},

		positioneraOmDialogenOmDenOverflowarBody() {
			this.arSlutpositionerad = true;

			// Tooltips måste nu bindas om, för den nyskapade dislogen kan innehålla sådana:
			// Todo: (görs för hela sidan och jag tror *utan* att de gamla bindningarna avbinds! Osäker om det kan ge minnesläckor!):
			ssoTooltips.ominitiera();
		},

		inaktiveraOchStangDenOppnadeDialogen() {
			//console.log('inaktiveraOchStangDenOppnadeDialogen', `[${this.uniktIdNr}]`, `${(this.visaDialogen ? 'visas' : '     ')} ${(this.arOverstaDialogen ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

			// Obs! När denna metod anropas så är det *alltid* fråga om att Avbryt "valts" i dialogen:
			this.$emit('avbryt-i-dialog');

			// Propen används med .sync i parent component:
			this.$emit('update:vpVisaDialogen', false);

			// Resten av stängningen/inaktiveringen sker reaktivt genom watch!
		},

		startaEventLyssningForStangningAvDialogen() {
			//console.log('startaEventLyssningForStangningAvDialogen', `[${this.uniktIdNr}]`, `${(this.visaDialogen ? 'visas' : '     ')} ${(this.arOverstaDialogen ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

			// Dessa event-listeners kan inte addas som anonymous arrow functions (för att hantera "this") eftersom de ska removeas senare. "There is no way to cleanly remove an event handler unless you stored a reference to the event handler at creation.":

			document.addEventListener('keydown', this.onKeyDown);

			let el = document.getElementById(this.portalTargetName);
			if (el)
			{
				el.addEventListener('mousedown', this.onEventSomKanskeSkaStangaDialogen, { passive: true });
				el.addEventListener('touchstart', this.onEventSomKanskeSkaStangaDialogen, { passive: true });
			}
			else
			{
				console.error(`startaEventLyssningForStangningAvDialogen: Elementet '${this.portalTargetName}' hittades inte!`);
			}
		},

		stoppaEventLyssningForStangningAvDialogen() {
			//console.log('stoppaEventLyssningForStangningAvDialogen', `[${this.uniktIdNr}]`, `${(this.visaDialogen ? 'visas' : '     ')} ${(this.arOverstaDialogen ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

			//let that = this;
			// window.addEventListener('keydown', function(e) {return that.someMethod(e);});
			// Går inte, för den måste tas bort med SAMMA metod som den skapades: document.removeEventListener('keydown', (e) => that.stangDialogen(e));

			document.removeEventListener('keydown', this.onKeyDown);

			let el = document.getElementById(this.portalTargetName);
			if (el)
			{
				el.removeEventListener('mousedown', this.onEventSomKanskeSkaStangaDialogen);
				el.removeEventListener('touchstart', this.onEventSomKanskeSkaStangaDialogen);
			}
			else
			{
				console.error(`stoppaEventLyssningForStangningAvDialogen: Elementet '${this.portalTargetName}' hittades inte!`);
			}
		},

		onKeyDown(e) {
			//console.log(e);

			if (e.defaultPrevented) {
				return; // Do nothing if the event was already processed
			}

			//console.log(`Tangent: key="${e.key}", keycode=${e.keyCode}, key.charCodeAt(0)=${e.key.charCodeAt(0)}`);

			if (e.key === 'Escape')
			{
				this.inaktiveraOchStangDenOppnadeDialogen();	// = Avbryt

				// Cancel the default action to avoid it being handled twice
				event.preventDefault();
				return;
			}

			if (e.key === 'Enter')
			{
				// Välj standardknappen i dialogen:

				// Cancel the default action to avoid it being handled twice
				event.preventDefault();

				this.onKnappTryckt(this.vpDialogConfig.standardknappIndex);
				return;
			}
		},

		onEventSomKanskeSkaStangaDialogen(e) {

			// Obs! Denna används för *flera olika* events!

			//console.log(e);

			// Kolla om det är ett event som *inte* ska stänga dialogen:

			if (e.type === 'mousedown' || e.type === 'touchstart')
			{
				if (e.target === this.$refs.rutan
					|| this.$refs.rutan.contains(e.target)
				)
				{
					// Om man klickat på själva dialogelementet
					// ELLER något element i dialogelementet (ancestor):
					// Stäng *inte* dialogen:
					return;
				}
			}

			// Cancel the default action to avoid it being handled twice
			event.preventDefault();

			this.inaktiveraOchStangDenOppnadeDialogen();	// = Avbryt
		},


		//==================================================================================================================

		onKnappTryckt(knappIndex) {

			// js-variant of linq firstOrDefault():https://gist.github.com/DanDiplo/30528387da41332ff22b:
			//let alt = this.vpMenyConfig.menydelar.filter(function (alt) { return alt.id === id; })[0] || null;
			let knapp = this.vpDialogConfig.knappar[knappIndex];

			switch (knapp.typ)
			{
				case euiDialogClasses.knappTypEnum.AVBRYT:
					{
						// Bara stäng dialogen:
						this.inaktiveraOchStangDenOppnadeDialogen();	// = Avbryt
						break;
					}

				case euiDialogClasses.knappTypEnum.EVENT:
					{
						// Om ett event ska emittas:

						// Obs! Hit kan man faktiskt komma *även* om knappen är otillgänglig (ex.vis Enter tryckt):

						if (knapp.validateBeforeEmit)
						{
							// Om formulärfält ska valideras innan eventet avfyras:

							// Hade även kunnat kolla *utan* att visa felmeddelanden, så här: getValidationObserverMergedState() ...
							// Obs! validate() returnerar ett "promise<bool>":
							this.$refs.panelen.validate()
								.then((isValid) => {

									if (!isValid) {
										// Om formuläret inte validerar:
										// Då har feltexter visats i formuläret:
										// Bara aborta emittandet.
									}
									else
									{
										// Allt validerar *client-side* (*standard-valideringar*):
										this.$emit('knapp-tryckt-i-dialog',
											// Payload:
											{ eventId: knapp.eventId, eventData: knapp.eventData }
										);
									}

								});
						}
						else
						{
							// Annars: Om formulärfält *inte* ska valideras innan eventet avfyras:
							this.$emit('knapp-tryckt-i-dialog',
								// Payload:
								{ eventId: knapp.eventId, eventData: knapp.eventData }
							);
						}

						break;
					}

				// Utgått: Ersätts av typ EVENT ovan:
				//case euiDialogClasses.knappTypEnum.SUBMIT_FORM:
				//	{
				//		// Om (det *enda*) formuläret i dialogen ska submittas:
				//		// Obs! Själva submitten görs *inte* här, men eventets payload (eventId och eventData) laddas på särskild sätt nedan:

				//		// Obs! Hit kan man faktiskt komma *även* om knappen är otillgänglig (ex.vis Enter tryckt):

				//		// Hade även kunnat kolla *utan* att visa felmeddelanden, så här: getValidationObserverMergedState() ...
				//		// Obs! validate() returnerar ett "promise<bool>":
				//		this.$refs.panelen.validate()
				//			.then((isValid) => {

				//				if (!isValid) {
				//					// Om formuläret inte validerar:
				//					// Då har feltexter visats i formuläret:
				//					// Bara aborta submittandet.
				//				}
				//				else
				//				{
				//					// Allt validerar *client-side* (*standard-valideringar*):

				//					//this.stangDialogen();

				//					const formularet = this.$refs.rutan.querySelector('form');
				//					const formData = new FormData(formularet);

				//					// Note: Only successful form controls are included in a FormData object, i.e. those with a name, not disabled and checked (radio buttons and checkboxes) or selected (one or more options within a select).

				//					//// Skapa objektet att POSTa:
				//					//let dataAttPosta = {};
				//					//for(var pair of formData.entries()) {
				//					//	dataAttPosta['' + pair[0]] = pair[1];
				//					//}
				//					//console.log('dataAttPosta:', dataAttPosta);

				//					//this.$emit('submitta-formular-i-dialog',
				//					this.$emit('knapp-tryckt-i-dialog',
				//						// Payload:
				//						{
				//							eventId: knapp.eventId,
				//							eventData: formData
				//						}
				//					);
				//				}

				//			});

				//		break;
				//	}
			}

		},

		getValidationObserverMergedState() {
			return this.$refs.panelen.ctx;
		},


		//==================================================================================================================

		onDragAndDrop(e) {

			//console.log('Dialog släpad:', e.type, e.center.x, e.center.y, e.deltaX, e.deltaY);

			let eventName = null;

			switch (e.type) {
				case 'panstart':
				case 'panstart-virtuellt-custom':
				{
					this.isBeeingMoved = true;

					// Spara undan lite startdata:

					this.draggingFromElementPosition.x = this.$refs.rutan.offsetLeft;	// 'offsetX' = "outer", medan 'clientX' = inner med border och ev rulln.list borträknad.
					this.draggingFromElementPosition.y = this.$refs.rutan.offsetTop;

					// Flytta vid behov:
					this.flyttaEnligtHammerEvent(e);

					eventName = 'dialogDraggingStarted';
					break;
				}

				case 'panmove':
				case 'panmove-virtuellt-custom':
				{
					// Flytta vid behov:
					let andrat = this.flyttaEnligtHammerEvent(e);

					if (andrat)
					{
						eventName = 'dialogDragged';
						// Annars fortsätter den vara null och bubblar inte upp till... nedan.
					}

					break;
				}

				// Hanterar inte pancancel. Den skickas i tid och otid och det är för mig oklart vad exakt den innebär!
				// Vid senare tester skickas den *inte* i tiod och otid (får den inte alls faktiskt). Viss extern exempelkod antyder att den inträffar när musen läm,nar objektet (man drar för snabbt) eller när musen lämnar containern/skärmen eller nåt sånt. Hanterar den tills vidare identiskt med det egna special-"eventet" panavbruten:
				case 'pancancel':
				case 'panavbruten-custom':
				{
					// panavbruten är ett *custom* special-Hammer-"event" *utan* andra properties än "type":

					// Återställ till platsen då flyttningen inleddes:
					this.draggedToElementPosition.x = this.draggingFromElementPosition.x;
					this.draggedToElementPosition.y = this.draggingFromElementPosition.y;

					this.stoppaPagaendeDragginghantering();

					eventName = 'dialogDraggingCanceled';
					break;
				}

				case 'panend':
				{
					this.stoppaPagaendeDragginghantering();
					eventName = 'dialogDropped';

					break;
				}

				default:
				{
					console.error('Ogiltigt pan-event detekterat!');
				}
			}

			if (eventName)
			{
				// Skicka ett anpassat Vue-event till dialogens parent:
				this.$parent.$emit(eventName, {
					dialogComponent: this,		// ref till denna vue-komponent
					hammerEvent: e
				});
			}
		},

		flyttaEnligtHammerEvent(e) {
			let left = this.draggingFromElementPosition.x + e.deltaX;
			let top = this.draggingFromElementPosition.y + e.deltaY;

			// Vid dessa begränsningar struntar vi i att padding kan finnas, som egentligen begränsar disponiber yta ännu mer. Då slipper vi en tidsödande (?) gettning av computedStyle. *Dock* blir det fult om en vertikal rullningslist visas som "overlay", så här förutsätter vi lite fräckt att en sådan kan visas + att panelytan har en padding för detta i högerkant och minskar gränsen (i högerkant) med fast värde för att ta höjd för det  :/

			if (left < 0)
				left = 0;

			if (top < 0)
				top = 0;

			let maxLeft = window.innerWidth - this.$refs.rutan.offsetWidth -18;	// 'offsetX' = "outer", medan 'clientX' = inner med border och ev rulln.list borträknad.	// -18: Se kommentar ovan.

			if (left > maxLeft)
				left = maxLeft;

			let maxTop = window.innerHeight - this.$refs.rutan.offsetHeight;

			if (top > maxTop)
				top = maxTop;

			const ärOmpositionerad = (
					left !== this.draggedToElementPosition.x
					|| top !== this.draggedToElementPosition.y
				);

			if (ärOmpositionerad)
			{
				// Ompositioneringen (+ absolut positionering ist.f. flex) sker medelst Vue reaktivitet:
				this.draggedToElementPosition.x = left;
				this.draggedToElementPosition.y = top;

				// Returnera att platsen har ändrats:
				return true;
			}

			// Ingen faktisk flyttning har skett:
			return false;
		},

		stoppaPagaendeDragginghantering() {

			this.isBeeingMoved = false;

			//// Ta bort och avveckla "drag handle":
			//this.dragHandleEl.remove();	// Ta bort från DOM.
			//this.dragHandleEl = null;

			//// Sätt tillbaka cursorn (ta bort inline style):
			//this.$el.style.cursor = '';
		},

	},


	//== Lifecycle hooks  ================================================================================================================

	beforeCreate() {
		// Called synchronously immediately after the instance has been initialized, before data observation and event/watcher setup.
		//console.log('beforeCreate: dialog', `[${this.uniktIdNr}]`, `${(this.visaDialogen ? 'visas' : '     ')} ${(this.arOverstaDialogen ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

		// Deklaration av "private" variabler, som är "non reactive properties of this instance" (ett alt sätt är att anv data, men sätta värdet till Object.freeze(värde)):
		// Exempel: this.$_undertryckNastaAndradEvent = false;

		this.$_undansparatActiveElement = undefined;
	},

	created()
	{
		// Called synchronously after the instance is created. At this stage, the instance has finished processing the options which means the following have been set up: data observation, computed properties, methods, watch/event callbacks. However, the mounting phase has not been started, and the $el property will not be available yet.

		// Lägg till vanligt html-element som ska användas som portal-target:
		// Obs! Måste ligga utanför appen, för att inte skrivas över och försvinna när appen mountas/updateas!
		let el = document.createElement('div');
		el.setAttribute('id', this.portalTargetName);

		//// För att kunna fånga tangenttryck på detta el:
		//el.setAttribute('tabindex', '0');

		//document.body.insertAdjacentElement('afterbegin', el);	// 'afterbegin': Just inside the targetElement, before its first child.
		document.body.insertAdjacentElement('beforeend', el);	// 'beforeend': Just inside the targetElement, after its last child. För att nestade dialoger ska hamna över sin "parent" (syskon som ligger tidigare i html-sekvens).
	},

	//beforeUpdate()
	//{
	//	console.log('beforeUpdate');
	//},

	updated()
	{
		//console.log('updated');

		if (this.vpElementMedDettaIdFlyttasVidVisningTillSistInomKroppensContainer)
		{
			if (this.visaDialogen)
			{
				// Om update-eventet är *ett av multipla* (?) som skickas då dialogrutan ska växla från dold => visas:

				//! "Note that updated does not guarantee that all child components have also been re-rendered. If you want to wait until the entire view has been re-rendered, you can use vm.$nextTick inside of updated:
				this.$nextTick(function () {
					// Code that will run only after the entire view has been re-rendered:

					let elToMoveIntoContainer = document.getElementById(this.vpElementMedDettaIdFlyttasVidVisningTillSistInomKroppensContainer);

					if (this.$refs.rutan
						&& !this.$refs.kroppensInnehall.contains(elToMoveIntoContainer)
					)
					{
						// ...och dialogrutan finns i DOM (behöver *inte* synas på skärmen än) (...men det går den i och med nextTick ovan!!)
						// OCH det inte redan är inflyttat till dialogrutans kropp:

						// Flytta in detta el från body till dialogrutans kropp:
						let targetContainerEl = this.$refs.kroppensInnehall;	// document.getElementById('docTargetEl');
						targetContainerEl.appendChild(elToMoveIntoContainer);
						elToMoveIntoContainer.style.display = 'flex';		// none => flex
					}
				});
			}
			else
			{
				// Annars är update-eventet är *ett av multipla* (?) som skickas då dialogrutan ska växla från visas => dold:

				//! "Note that updated does not guarantee that all child components have also been re-rendered. If you want to wait until the entire view has been re-rendered, you can use vm.$nextTick inside of updated:
				//this.$nextTick(function () {
				//	// Code that will run only after the entire view has been re-rendered:
				//});

				let elToMoveIntoContainer = document.getElementById(this.vpElementMedDettaIdFlyttasVidVisningTillSistInomKroppensContainer);

				if (this.$refs.rutan
					&& this.$refs.kroppensInnehall.contains(elToMoveIntoContainer)
				)
				{
					// ...och dialogrutan (fortf) finns i DOM
					// OCH det inte redan är tillbakaflyttat till body:

					// Flytta tillbaka detta el från dialogrutans kropp till body:
					let targetContainerEl = document.body;
					targetContainerEl.appendChild(elToMoveIntoContainer);
					elToMoveIntoContainer.style.display = 'none';		// flex => none
				}
			}
		}
	},

	mounted() {
		// Note that mounted does not guarantee that all child components have also been mounted.
		//-----------------------------------------------------------------------------------------------------------------------
		// Mixin hooks will be called *before* the component’s/app’s own hooks. Ordning:
		//
		// 1. Mixins mounted hook.
		// 2. Appens/komponentens mounted hook.
		//
		// 3. Mixins mounted hook + nextTick (DOM not updated yet).
		// 4. Appens/komponentens mounted hook + nextTick (DOM not updated yet).
		//
		// 5. Mixins mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated).
		// 6. Appens/komponentens mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated).
		//
		// Det är *först efter steg 4* ovan som allt är färdigrenderat, med avseende på Vue-grejs som exempelvis all reaktivitet som förekommer i appen (ex visa/dölj element)!
		//
		// Alltså, saker som ska göras i denna mixins mounted och som ska ske *efter* steg 2 ovan:
		// a) kan göras som steg 3 ovan, *om* det *inte* är beroende av att allt reaktivt är garanterat färdigrenderat eller
		// b) måste göras som steg 5 ovan, *om* det är beroende av att allt reaktivt är garanterat färdigrenderat.
		//-----------------------------------------------------------------------------------------------------------------------
		//console.log('mounted: dialog', this.vpVisaDialogen, this.visaDialogen, `[${this.uniktIdNr}]`, `${(this.visaDialogen ? 'visas' : '     ')} ${(this.arOverstaDialogen ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

		//## 2. Appens/komponentens mounted hook:  #################################
		//console.log('2. Appens/komponentens mounted hook');

		this.$nextTick(function () {
			// Code that will run only after the entire Vue view has been rendered (= guarantee that all child components have also been mounted):
			// This is the same as the global Vue.nextTick, except that the callback’s this context is automatically bound to the instance calling this method:

			//## 4. Appens/komponentens mounted hook + nextTick (DOM not updated yet):  #################################
			//console.log('4. Appens/komponentens mounted hook + nextTick');

			//console.log('mounted+NextTick: dialog', this.vpVisaDialogen, this.visaDialogen, `[${this.uniktIdNr}]`, `${(this.visaDialogen ? 'visas' : '     ')} ${(this.arOverstaDialogen ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

			// FÖRST NU initieras visningen *om* den är satt via vpVisaDialogen att den ska visas initialt:
			this.visaDialogen = this.vpVisaDialogen;

			// Resten av initieringen sker reaktivt genom watch!
		});
	},

	beforeDestroy()
	{
		// Called right before a Vue instance is destroyed. At this stage the instance is still fully functional.
		// This hook is not called during server-side rendering.
		//console.log('beforeDestroy: dialog', this.vpVisaDialogen, this.visaDialogen, `[${this.uniktIdNr}]`, `${(this.visaDialogen ? 'visas' : '     ')} ${(this.arOverstaDialogen ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);
		//console.log('beforeDestroy dialog', `[${this.uniktIdNr}]`, `${(this.visaDialogen ? 'visas' : '     ')} ${(this.arOverstaDialogen ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

		// För den eventualitet att denna komponent hinner destroyas *innan* den via reaktivitet hinner inaktivera sig själv. Det spelar mindre roll för saker som bara berör denna komponent, som alltså inte finns längre, men om det ex.vis gäller event-bindningarna till window/document (utanför denna komponent) så får de *absolut* inte ligga kvar när komponenten är destoryad!
		// Därav denna hantering här + att jag för säkerhets skull gjort event-bortbindningen så att den pallar att göras även då inga event är bundna:
		this.inaktiveraDialogenOmDenArAktiverad();

		if (this.$_undansparatActiveElement)
			this.$_undansparatActiveElement.focus();
	},

	destroyed()
	{
		// Called after a Vue instance has been destroyed. When this hook is called, all directives of the Vue instance have been unbound, all event listeners have been removed, and all child Vue instances have also been destroyed.
		// This hook is not called during server-side rendering.
		//console.log('destroyed dialog', `[${this.uniktIdNr}]`, `${(this.visaDialogen ? 'visas' : '     ')} ${(this.arOverstaDialogen ? 'överst' : '     ')} ${(this.arAktiverad ? 'aktiv' : '     ')}`);

		// Ta bort portal-target-elementet från DOM (om det ligger kvar):
		let el = document.getElementById(this.portalTargetName);
		if (el)
			el.remove();

		// NEJ, detta görs nu the Vue way direkt i rotappen (allaSidorMixin):
		//// Trixa lite med DOM utanför den här komponenten:
		//if (this.antalDialogerPaStacken == 0)
		//{
		//	// Om den sista dialogen togs bort från stacken:
		//	this.$root.$el.classList.remove('-diffus');
		//}
	},
};
